document.addEventListener("DOMContentLoaded", function () {
    const variantLabels = document.querySelectorAll("variant-picker label.opt-label"); // Target PDP variant labels.

    if (variantLabels.length === 0) {
        return;
    }

    // Fetch product data correctly
    fetch(window.location.pathname + ".json")
        .then(response => response.json())
        .then(data => {
            const variants = data.product.variants || [];
            const selectors = Array.from(document.querySelectorAll("variant-picker .option-selector"));

            variantLabels.forEach(label => {
                const variantSpan = label.querySelector(".js-value"); // Locate the variant text inside the label
                if (!variantSpan) return;

                const optionValue = variantSpan.textContent.trim(); // Get variant name
                const selector = label.closest(".option-selector");
                const optionIndex = selectors.indexOf(selector);
                const matchingVariants = variants.filter(variant => {
                    if (Array.isArray(variant.options) && variant.options[optionIndex] === optionValue) {
                        return true;
                    }

                    return variant[`option${optionIndex + 1}`] === optionValue || variant.title === optionValue;
                });

                if (matchingVariants.length > 0) {
                    const trackedVariants = matchingVariants.filter(variant => variant.inventory_management);
                    if (trackedVariants.length === 0) return;

                    const inventoryQuantity = Math.max(0, trackedVariants.reduce((total, variant) => {
                        return total + (Number(variant.inventory_quantity) || 0);
                    }, 0));
                    let stockBadge = label.querySelector(".variant-stock-badge");

                    if (inventoryQuantity > 0 && !stockBadge) {
                        stockBadge = document.createElement("span");
                        stockBadge.className = "variant-stock-badge";
                        label.appendChild(stockBadge);
                    }

                    if (stockBadge && inventoryQuantity > 0) {
                        stockBadge.dataset.stockQuantity = inventoryQuantity;
                        stockBadge.setAttribute("aria-label", `${inventoryQuantity} in stock`);
                        stockBadge.textContent = `Qty In Stock x ${inventoryQuantity}`;
                    } else if (stockBadge) {
                        stockBadge.remove();
                    }

                    label.classList.toggle("variant-instock", inventoryQuantity > 0);
                    label.classList.toggle("variant-unavailable", inventoryQuantity <= 0);
                    variantSpan.setAttribute("data-stock-status", inventoryQuantity <= 0 ? "(Out of Stock)" : "");
                }
            });
        })
        .catch(error => console.error("Error fetching variant data:", error));
});

document.addEventListener("DOMContentLoaded", function () {
    const thumbnailSelectors = [
        ".MagicToolboxContainer .MagicToolboxSelectorsContainer"
    ];

    const updateThumbnailScrollHints = () => {
        thumbnailSelectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(container => {
                const overflows = container.scrollWidth > container.clientWidth + 8;
                container.classList.toggle("has-scroll-hint", overflows);
            });
        });
    };

    updateThumbnailScrollHints();
    setTimeout(updateThumbnailScrollHints, 500);
    setTimeout(updateThumbnailScrollHints, 1500);
    window.addEventListener("resize", updateThumbnailScrollHints);

    const observer = new MutationObserver(updateThumbnailScrollHints);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
